import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../Error.js";
import r from "../has.js";
import { throwIfAborted as e } from "../promiseUtils.js";
import o from "./Connection.js";
export { default as Connection } from "./Connection.js";
import n from "./RemoteClient.js";
export { default as RemoteClient } from "./RemoteClient.js";
import i from "./WorkerOwner.js";
var s = r("esri-workers-debug") ? 1 : r("host-browser") ? navigator.hardwareConcurrency - 1 : 0;
s || (s = r("safari") && r("mac") || r("trident") ? 7 : 2);
var a = 0;
var l = [];

function c() {
  h();
}

function m(t, r) {
  return f(t, {
    client: r
  });
}

function f(_x, _x2) {
  return _f.apply(this, arguments);
}

function _f() {
  _f = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t, r) {
    var e;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            e = new o();
            _context.next = 3;
            return e.open(t, r);

          case 3:
            return _context.abrupt("return", e);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _f.apply(this, arguments);
}

function u(_x3) {
  return _u.apply(this, arguments);
}

function _u() {
  _u = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(o) {
    var i,
        c,
        _t2,
        _r,
        _t3,
        _t4,
        _r2,
        _e,
        _t5,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            i = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};

            if (!("string" != typeof o)) {
              _context2.next = 3;
              break;
            }

            throw new t("workers:undefined-module", "modulePath is missing");

          case 3:
            c = i.strategy || "distributed";

            if (!(r("host-webworker") && !r("esri-workers") && (c = "local"), "local" === c)) {
              _context2.next = 16;
              break;
            }

            _context2.next = 7;
            return n.loadWorker(o);

          case 7:
            _t2 = _context2.sent;
            _context2.t0 = _t2;

            if (_context2.t0) {
              _context2.next = 13;
              break;
            }

            _context2.next = 12;
            return import(
            /* @vite-ignore */

            /* webpackIgnore: true */
            o);

          case 12:
            _t2 = _context2.sent;

          case 13:
            e(i.signal);
            _r = i.client || _t2;
            return _context2.abrupt("return", f([n.connect(_t2)], _objectSpread(_objectSpread({}, i), {}, {
              client: _r
            })));

          case 16:
            _context2.next = 18;
            return h();

          case 18:
            e(i.signal);

            if (!("dedicated" === c)) {
              _context2.next = 28;
              break;
            }

            _t3 = a++ % s;
            _context2.t1 = f;
            _context2.next = 24;
            return l[_t3].open(o, i);

          case 24:
            _context2.t2 = _context2.sent;
            _context2.t3 = [_context2.t2];
            _context2.t4 = i;
            return _context2.abrupt("return", (0, _context2.t1)(_context2.t3, _context2.t4));

          case 28:
            if (!(i.maxNumWorkers && i.maxNumWorkers > 0)) {
              _context2.next = 34;
              break;
            }

            _t4 = Math.min(i.maxNumWorkers, s);

            if (!(_t4 < s)) {
              _context2.next = 34;
              break;
            }

            _r2 = new Array(_t4);

            for (_e = 0; _e < _t4; ++_e) {
              _t5 = a++ % s;
              _r2[_e] = l[_t5].open(o, i);
            }

            return _context2.abrupt("return", f(_r2, i));

          case 34:
            return _context2.abrupt("return", f(l.map(function (t) {
              return t.open(o, i);
            }), i));

          case 35:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _u.apply(this, arguments);
}

function p() {
  d && (w.abort(), d = null);

  for (var _t = 0; _t < l.length; _t++) {
    l[_t] && l[_t].terminate();
  }

  l.length = 0;
}

var w,
    d = null;

function h() {
  return _h.apply(this, arguments);
}

function _h() {
  _h = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var t, _loop, _r3;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!d) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return", d);

          case 2:
            w = new AbortController();
            t = [];

            _loop = function _loop(_r3) {
              var e = i.create(_r3).then(function (t) {
                return l[_r3] = t, t;
              });
              t.push(e);
            };

            for (_r3 = 0; _r3 < s; _r3++) {
              _loop(_r3);
            }

            return _context3.abrupt("return", (d = Promise.all(t), d));

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _h.apply(this, arguments);
}

export { c as initialize, u as open, m as openWithPorts, p as terminate };